module.exports = __webpack_public_path__ + "img/mlabs.4bb1dce0.png";